import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MonitoringImage } from '../../cctv-monitoring.models';
import { imageAge } from '../../cctv-monitoring.utils';

@Component({
  selector: 'app-image-tile',
  templateUrl: './image-tile.component.html',
  styleUrls: ['./image-tile.component.css'],
})
export class ImageTileComponent implements OnChanges {
  @Input() image!: MonitoringImage;
  @Input() pinned = false;
  @Output() readonly pin = new EventEmitter<void>();
  @Output() readonly zoom = new EventEmitter<void>();
  imageSrc = '';
  imageFailed = false;

  ngOnChanges(): void {
    this.imageSrc = this.image.thumbnailUrl;
    this.imageFailed = false;
  }

  onImageError(): void {
    if (this.imageSrc !== this.image.fullUrl) this.imageSrc = this.image.fullUrl;
    else this.imageFailed = true;
  }

  get status(): string {
    const age = imageAge(this.image);
    return age === null ? 'نامشخص' : age <= 90 ? 'تازه' : age <= 180 ? 'تأخیردار' : 'قدیمی';
  }

  get dateLabel(): string {
    const date = new Date(this.image.date);
    return this.image.date && !isNaN(date.getTime()) ? date.toLocaleString('fa-IR') : this.image.ageText || 'زمان نامشخص';
  }
}
